import { COUNTRIES_PHONE_FORMAT, CountryWithPhoneFormat } from 'config';

export const formatPhoneKaz = (inputNumbers: string) => {
  const { countryCode } =
    COUNTRIES_PHONE_FORMAT[CountryWithPhoneFormat.Kazakhstan]!;

  let formattedInputValue = `${countryCode} `;

  if (inputNumbers.length === 1) {
    formattedInputValue = `${formattedInputValue}(${inputNumbers.substring(
      0,
      1,
    )}`;
  }
  if (inputNumbers.length > 1) {
    formattedInputValue = `${formattedInputValue}(${inputNumbers.substring(
      1,
      4,
    )}`;
  }
  if (inputNumbers.length >= 5) {
    formattedInputValue = `${formattedInputValue}) ${inputNumbers.substring(
      4,
      7,
    )}`;
  }
  if (inputNumbers.length >= 8) {
    formattedInputValue = `${formattedInputValue}-${inputNumbers.substring(
      7,
      9,
    )}`;
  }
  if (inputNumbers.length >= 10) {
    formattedInputValue = `${formattedInputValue}-${inputNumbers.substring(
      9,
      11,
    )}`;
  }

  return formattedInputValue;
};
